'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';

import { SHAREHOLDERS_TAB_TITLE_ID } from '../constants';
import type { ShareholdersTabTitleFocusProps } from '../ShareholdersSection.types';

export default function ShareholdersTabTitleFocus({
    children,
}: ShareholdersTabTitleFocusProps) {
    const pathname = usePathname();
    const previousPathname = useRef(pathname);

    useEffect(() => {
        if (previousPathname.current === pathname) {
            return;
        }

        previousPathname.current = pathname;

        document
            .getElementById(SHAREHOLDERS_TAB_TITLE_ID)
            ?.focus({ preventScroll: true });
    }, [pathname]);

    return children;
}
